/*
 * Avatar: a person's initials on a neutral gray. Hosterr itself
 * (nightly backups, checks) shows a picture instead, passed as src. An unknown
 * person is a plain gray "?", never a guess.
 */
import { cx } from "../lib/cx";
import { initials } from "../lib/format";

export function Avatar({
  name,
  size = 24,
  src,
  ring,
  className,
}: {
  /** The person's name; null or empty when it isn't known. */
  name: string | null | undefined;
  size?: number;
  /** A picture instead of initials (Hosterr's mark for work it did itself). */
  src?: string | null;
  /** A ring in the surface color, for avatars that overlap a line or each other. */
  ring?: boolean;
  className?: string;
}) {
  const known = !!name?.trim();
  const label = known ? name!.trim() : "Someone not known";
  const base = "inline-grid shrink-0 place-items-center overflow-hidden rounded-full font-semibold leading-none select-none";
  const style = { width: size, height: size, fontSize: Math.max(9, Math.round(size * 0.38)) };
  const ringCls = ring ? "outline-2 outline-surface" : undefined;
  if (src) {
    return (
      <span role="img" aria-label={label} title={label} className={cx(base, "bg-white shadow-[inset_0_0_0_1px_var(--hx-line)]", ringCls, className)} style={style}>
        <img src={src} alt="" className="h-[62%] w-[62%] object-contain" />
      </span>
    );
  }
  if (!known) {
    return (
      <span role="img" aria-label={label} title={label} className={cx(base, "bg-track text-dim", ringCls, className)} style={style}>
        ?
      </span>
    );
  }
  return (
    <span role="img" aria-label={label} title={label} className={cx(base, "hx-avatar", ringCls, className)} style={style}>
      {initials(label)}
    </span>
  );
}
